import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

import '../doomscroll.css';
import '../components/components.css';

import { getPostData } from '../db/getPostData';

// Components
import convertSpecialCharacters from '../components/convertSpecialCharacters';
import convertStringtoHTML from '../components/convertStringtoHTML';
import ImageWithFallBack from '../components/ImageFallBack';
import ReleasedIcon from '../components/releasedIcon';
import FullscreenImage from '../components/fullscreenImage';
import checkGame from '../components/checkGame';

// Images
import BackArrow from '../images/icons/arrow-left-solid-full.svg';
import D1GrimoireIcon from '../images/D1GrimoireIcon.png';
import BasicIcon from '../images/Patrol.png';
import QuestIcon from '../images/Quest1.png';
import InventoryIcon from '../images/inventory.png';
import NotLikedIcon from '../images/icons/heart-regular-full.svg';
import LikedIcon from '../images/icons/heart-solid-full.svg';
import LoreEntryIcon from '../images/lore entry.png';



interface PostInfo {
    description: string | null,
    hash: number,
    icon: string | null,
    image: string | null,
    itemtypeandtierdisplayname: string | null,
    lorebookname: string | null,
    lorehash: number | null,
    name: string,
    released: string | null,
    shortdescription: string | null,
    subtitle: string | null,
    doctype: string | null
}

export default function FullPostPage() {

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();


    const [postInfo, setPostInfo] = useState<PostInfo>();
    const [loading, setLoading] = useState<boolean>(true);

    const [liked, setLiked] = useState<boolean>(false);

    const [displayFullImage, setDisplayFullImage] = useState<boolean>(false);

    function closeFullscreenImage() {
        setDisplayFullImage(false);
    }

    function navigateBack() {
        navigate(-1);
    }

    async function getPost(hash: number) {
        try {
            const res: any = await getPostData(hash);
            
            console.log(res);
            setPostInfo(res);
            setLoading(false);
        }
        catch(e) {
            console.log(e);
        }
    }

    useEffect(() => {
        getPost(Number(searchParams.get("hash")));
    }, []);

    if(loading) {
        return(
            <>            
                <div className="full-post-container">
                    <h2 className="post-header"><img src={BackArrow} onClick={() => {}} />  </h2>

                    <div
                        style={{
                            padding: '2rem',
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '50px'
                        }}
                    >
                        <span className="loader"></span>
                    </div>
                </div>
            </>
        );
    }
    else if(loading === false && postInfo !== undefined) {
        if(postInfo.doctype === "Lore Entry") {
            return(
                <>
                    {displayFullImage && <FullscreenImage image={postInfo.image!} type="wide" close={closeFullscreenImage} />}
                    <div className="full-post-container book">
                        <h2 className="post-header"><img src={BackArrow} onClick={navigateBack} /> Lore </h2>
                        
                        <div className="post-container-display">
                            <div className="top-row">
                                <div className="post-name">
                                    <h3>{postInfo.name}</h3>
                                    <div>{postInfo.lorebookname}</div>
                                </div>
                                
                                <span className="post-category">Lore Entry
                                    <span className="image-container"><img src={BasicIcon} /></span>
                                </span>
                            </div>

                            <div className="post-info">
                                <div className="image-container post-image" onClick={() => {setDisplayFullImage(true)}}>
                                    <ImageWithFallBack src={postInfo.image!} image_type="Lore Entry" alt="" />
                                </div>

                                <div className="bottom-row">
                                    <div className="align-right">
                                        <span>{postInfo.released}</span> <ReleasedIcon value={postInfo.released!} />
                                    </div>
                                </div>

                                <div className="post-content">
                                    <div className="flavor-text">{postInfo.subtitle}</div>
                                    <div className="description short">{convertStringtoHTML(postInfo.description!)}</div>
                                </div>
                            </div>

                            <div className="bottom-row">

                                {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                                    {liked && <img src={LikedIcon} className="liked"/>}
                                    {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                                </div> */}
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        else if(postInfo.doctype === "Lore Book" || postInfo.itemtypeandtierdisplayname === "Lore Book") {
            return(
                <>
                    {displayFullImage && <FullscreenImage image={postInfo.image!} type="wide" close={closeFullscreenImage} />}
                    <div className="full-post-container lore book">
                        <h2 className="post-header"><img src={BackArrow} onClick={navigateBack} /> Lore </h2>
                        
                        <div className="post-container-display">
                            <div className="top-row">
                                <div className="post-name">
                                    <h3>{postInfo.name}</h3>
                                    <div>{postInfo.lorebookname}</div>
                                </div>
                                
                                <span className="post-category">Lore Book
                                    <span className="image-container"><img src={BasicIcon} /></span>
                                </span>
                            </div>

                            <div className="post-info">
                                <div className="image-container post-image" onClick={() => {setDisplayFullImage(true)}}>
                                    <ImageWithFallBack src={postInfo.image!} image_type="Lore Entry" alt="" />
                                </div>

                                <div className="bottom-row">
                                    <div className="align-right">
                                        <span>{postInfo.released}</span> <ReleasedIcon value={postInfo.released!} />
                                    </div>
                                </div>

                                <div className="post-content">
                                    <div className="description">{convertStringtoHTML(postInfo.description!)}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        else if(postInfo.itemtypeandtierdisplayname?.includes("Quest")) {
            return(
                <>
                    {displayFullImage && <FullscreenImage image={postInfo.icon!} type="wide" close={closeFullscreenImage} />}
                    <div className="full-post-container quest">
                        <h2 className="post-header"><img src={BackArrow} onClick={navigateBack} /> Quest </h2>
                        
                        <div className="post-container-display">
                            <div className="top-row">
                                <h3>{postInfo.name}</h3>
                                <span className="post-category">{postInfo.itemtypeandtierdisplayname!}
                                    <span className="image-container"><img src={QuestIcon} /></span>
                                </span>
                            </div>

                            <div className="post-info">
                                <div className="image-container post-image icon" onClick={() => {setDisplayFullImage(true)}}>
                                    <ImageWithFallBack src={postInfo.icon!} image_type={"Quest"} alt="" />
                                </div>

                                 <div className="bottom-row">
                                    <div className="align-right">
                                        <span>{postInfo.released}</span> <ReleasedIcon value={postInfo.released!} />
                                    </div>
                                </div>

                                <div className="post-content">
                                    <div className="description short">{convertStringtoHTML(postInfo.description!)}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        // Destiny 2 Item - icon
        else if(postInfo.doctype === "Item" && !postInfo.image && !checkGame(postInfo.released)) {
            return(
                <>
                    {displayFullImage && <FullscreenImage image={postInfo.image!} type="icon" close={closeFullscreenImage} />}
                    <div className="full-post-container quest" id={postInfo.hash.toString()}>
                        <h2 className="post-header"><img src={BackArrow} onClick={navigateBack} /> Item </h2>

                        <div className="post-container-display">
                            <div className="top-row">
                                <h3>{postInfo.name}</h3>
                                <span className="post-category">{postInfo.itemtypeandtierdisplayname}
                                    <span className="image-container"><img src={InventoryIcon} /></span>
                                </span>
                            </div>

                            <div className="post-info">
                                <div className="image-container post-image icon" onClick={() => {setDisplayFullImage(true)}}>
                                    <ImageWithFallBack src={postInfo.icon!} image_type={"Item"} alt="" />
                                </div>

                                <div className="bottom-row">
                                    <div className="align-right">
                                        <span>{postInfo.released!}</span> <ReleasedIcon value={postInfo.released!} />
                                    </div>
                                </div>

                                <div className="post-content">
                                    {postInfo.subtitle !== null && <div className="flavor-text">{convertStringtoHTML(postInfo.subtitle)}</div>}
                                    {postInfo.description !== null && <div className="description short">{convertStringtoHTML(postInfo.description!)}...</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        // Destiny 2 Item - image
        else if(postInfo.doctype === "Item" && postInfo.image && !checkGame(postInfo.released)) {
            return(
                <>
                    {displayFullImage && <FullscreenImage image={postInfo.image!} type="wide" close={closeFullscreenImage} />}
                    <div className="full-post-container" >
                        <h2 className="post-header"><img src={BackArrow} onClick={navigateBack} /> Item </h2>

                        <div className="post-container-display">
                            <div className="top-row">
                                <div className="post-name">
                                    <h3>{postInfo.name}</h3>
                                </div>
                                <span className="post-category">{postInfo.itemtypeandtierdisplayname}
                                    <span className="image-container"><img src={InventoryIcon} /></span>
                                </span>
                            </div>

                            <div className="post-info">
                                <div className="image-container post-image" onClick={() => {setDisplayFullImage(true)}}>
                                    <ImageWithFallBack src={postInfo.image!} image_type="Lore Entry" alt="" />
                                </div>

                                <div className="bottom-row">
                                    <div className="align-right">
                                        <span>{postInfo.released}</span> <ReleasedIcon value={postInfo.released!} />
                                    </div>
                                </div>

                                <div className="post-content">
                                    {postInfo.subtitle !== null && <div className="flavor-text">{convertStringtoHTML(postInfo.subtitle)}</div>}
                                    {postInfo.description !== null && <div className="description short">{convertStringtoHTML(postInfo.description!)}...</div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            );
        }
        // Destiny 1 Item
        else if(postInfo.doctype === "Item" && checkGame(postInfo.released)) {
            return(
                <>
                    {displayFullImage && <FullscreenImage image={postInfo.image!} type="icon" close={closeFullscreenImage} />}
                    <div className="full-post-container quest" >
                        <h2 className="post-header"><img src={BackArrow} onClick={navigateBack} /> Item </h2>

                        <div className="post-container-display">
                            <div className="top-row">
                                <h3>{postInfo.name}</h3>
                                <span className="post-category"> {postInfo.itemtypeandtierdisplayname}
                                    <span className="image-container"><img src={InventoryIcon} /></span>
                                </span>
                            </div>

                            <div className="post-info">
                                <div className="image-container post-image item" onClick={() => {setDisplayFullImage(true)}}>
                                    <ImageWithFallBack src={postInfo.icon!} image_type={postInfo.itemtypeandtierdisplayname!} alt="" />
                                </div>

                                <div className="post-content">
                                    {/* {postInfosubtitle !== null  && <div className="flavor-text">{convertStringtoHTML(subtitle)}</div>} */}
                                    {postInfo.description !== null && <div className="description short">{convertStringtoHTML(postInfo.description!)}...</div>}
                                </div>
                            </div>

                            <div className="bottom-row">
                                {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                                    {liked && <img src={LikedIcon} className="liked"/>} {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                                </div> */}

                                <div className="align-right">
                                    <span>{postInfo.released}</span> <ReleasedIcon value={postInfo.released!} />
                                </div>
                            </div>

                        </div>
                        <div className="bg-clickable-post" />
                    </div>
                </>
            );
        }
        else if(postInfo.itemtypeandtierdisplayname ==="Grimoire" && checkGame(postInfo.released)) {
            return(
                <>
                    {displayFullImage && <FullscreenImage image={postInfo.image!} type="tall" close={closeFullscreenImage} />}
                    <div className="full-post-container grimoire" >
                        <h2 className="post-header"><img src={BackArrow} onClick={navigateBack} /> Grimoire </h2>

                        <div className="post-container-display">
                            <div className="top-row">
                                <h3>{convertSpecialCharacters(postInfo.name)}</h3>
                                <span className="post-category">Grimoire
                                    <span className="image-container"><img src={D1GrimoireIcon} /></span>
                                </span>
                            </div>

                            <div className="post-info">
                                <div className="image-container post-image" onClick={() => {setDisplayFullImage(true)}}>
                                    <ImageWithFallBack src={postInfo.image!} image_type="Grimoire" alt={postInfo.name} />
                                </div>

                                <div className="bottom-row">
                                    <div className="align-right">
                                        <span>{postInfo.released}</span> <ReleasedIcon value={postInfo.released!} />
                                    </div>
                                </div>

                                <div className="post-content">
                                    {postInfo.description !== null && <div className="description short">{convertStringtoHTML(postInfo.description!)}...</div>}
                                </div>
                            </div>

                            <div className="bottom-row">

                                {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                                    {liked && <img src={LikedIcon} className="liked"/>}
                                    {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                                </div> */}

                                <div className="align-right">
                                    <span>{postInfo.released}</span> <ReleasedIcon value={postInfo.released!} />
                                </div>
                            </div>

                        </div>
                        

                        <div className="bg-clickable-post" />            
                    </div>
                </>
            );
        }
        else {
            return(
                <>
                    {displayFullImage && <FullscreenImage image={postInfo.image!} type="icon" close={closeFullscreenImage} />}
                    <div className="full-post-container quest" >
                        <h2 className="post-header"><img src={BackArrow} onClick={navigateBack} /> Lore </h2>

                        <div className="post-container-display">
                            <div className="top-row">
                                <h3>{postInfo.name}</h3>
                                <span className="post-category"> {postInfo.itemtypeandtierdisplayname} 
                                    {/* <span className="image-container"><img src={LoreEntryIcon} /></span> */}
                                </span>
                            </div>

                            <div className="post-info">
                                <div className="image-container post-image" onClick={() => {setDisplayFullImage(true)}}>
                                    <ImageWithFallBack src={postInfo.icon!} image_type={postInfo.itemtypeandtierdisplayname!} alt="" />
                                </div>

                                <div className="post-content">
                                    {/* {subtitle.length !== 0 && <div className="flavor-text">{convertStringtoHTML(subtitle)}</div>} */}

                                    {postInfo.description !== null && <div className="description short">{convertStringtoHTML(postInfo.description!)}...</div>}
                                </div>
                            </div>

                            <div className="bottom-row">

                                {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                                    {liked && <img src={LikedIcon} className="liked"/>} {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                                </div> */}

                                <div className="align-right">
                                    <span>{postInfo.released}</span> <ReleasedIcon value={postInfo.released!} />
                                </div>
                            </div>
                        </div>
                        <div className="bg-clickable-post" />
                    </div>
                </>
            );
        }
    }
    else {
        return(
            <div className="full-post-container quest" >
                <div className="post-container-display post-container template">
                    <div className="top-row">
                        <h3></h3>
                        <span className="post-category"> </span>
                    </div>

                    <div className="post-info">

                        <div className="post-content"> 
                            <div className="description short" />
                            <div className="description short" />
                            <div className="description short" />
                        </div>

                        <div className="image-container post-image" ></div>
                    </div>

                    <div className="bottom-row">

                        {/* <div className="like-button" onClick={() => {setLiked(!liked)}}>
                            {liked && <img src={LikedIcon} className="liked"/>}
                            {!liked && <img src={NotLikedIcon} className="not-liked"/>}
                        </div> */}

                        <div className="align-right">
                            <span></span>
                        </div>
                    </div>       
                </div>
            </div>
        );
    }
}